import '../css/Background.css';

const BackgroundComps = () => {
  return (
    <div id="About" class="card mx-auto">
      <div class="card-header text-center">Latar Belakang</div>
      <div class="card-body text-center">
        <p class="card-text">
          Indonesian Young Scientist Association (IYSA) adalah sebuah
          lembaga yang memfasilitasi pelajar Indonesia untuk dapat
          mengembangkan potensi di bidang keilmuan baik di dalam
          negeri maupun luar negeri. IYSA berdiri sebagai bentuk
          concern kami untuk memberikan kesempatan kepada pelajar
          Indonesia khususnya agar dapat memunculkan potensi dan
          skills yang dimiliki serta menumbuhkan jiwa kompetisi dalam
          diri mereka. Hal ini kami lakukan untuk menciptakan
          perbaikan kehidupan. Karena, kami yakin bahwa setiap orang
          memiliki potensi yang dapat dikembangkan.
        </p>
        <p class="card-text">
          LKTIN Smart Researcher merupakan salah satu kegiatan
          bagi pelajar di Indonesia untuk dapat menyalurkan pemikiran
          dalam bentuk gagasan, inovasi ataupun kreativitas dalam
          bentuk tertulis. Dibuat dengan ide yang kreatif dan memiliki
          sebuah konsep yang baru atau bisa juga dalam pengembangan
          dari ide yang telah dipublikasikan sebelumnya sebagai upaya
          dari tindak lanjut penelitian. LKTIN Smart Researcher merupakan salah satu kegiatan yang dapat meningkatkan kemampuan pelajar dalam mengembangkan bakat dan
          potensi yang dimiliki.
        </p>
        {/* <a href="#" class="btn btn-primary">
          Go somewhere
        </a> */}
      </div>
    </div>
  );
};

export default BackgroundComps;
